import {
    AppBar,
    Avatar,
    ButtonBase,
    Dialog,
    Grid,
    IconButton,
    List,
    ListSubheader,
    Snackbar,
    Tab,
    Tabs,
    Toolbar,
    Typography,
    withStyles,
    withRouter
} from '../../material-ui';
import React from 'react';

import { CopyToClipboard } from 'react-copy-to-clipboard';
import Swiper from 'react-id-swiper';
import 'video.js/dist/video-js.min.css';
import AppUtils from '../../control/apputlis';
import DateUtils from '../../control/dateutils';
import DeviceEventEmitter, { EventName } from '../../control/event';
import Profile from '../../control/Profile';
import FIMUtils from '../../im/FIMUtils';
import AppData from '../../model/AppData';
import Live from '../../model/Live';
import Match from '../../model/Match';
import MatchType from '../../model/MatchType';
import IMApp from '../../net/IMApp';
import IMEventEmitter, { IMEvent } from '../../net/IMEventEmitter';
import roomSocketMgr from '../../net/roomSocketMgr';
import Apis from '../../network/Apis';
import MBackIcon from '../view/MBackIcon';
import MStatusBar from '../view/MStatusBar';
import MTabPanel from '../view/MTabPanel';
import TabIndicator from '../view/TabIndicator';
import Player from './Player';
import './player.css';
import {
    Download,
    MovieAnalyseBasketBall,
    MovieAnalyseFootBall,
    MovieAnchor,
    MovieChat,
    MovieIndex,
    MovieIntelligence,
    MovieLive,
    MovieStateFootball,
    MovieTeamBasketball,
    MovieTeamFootball
} from './view';

import MovieStateBasket from './view/MovieStateBasket';
import DrawMarquee from './view/DrawMarquee';
import { OpenBrowser, ToLogin } from '../../control/ToName';

const BACK_BASKETBALL = require("../../images/bg/img_background_basketball.jpg");
const BACK_FOOTBALL = require("../../images/bg/img_background_basketball.jpg");
const sharlMatch = require("../../images/bg/sharlMatch.png");

const whbgc = require("../../images/bg/whbgc.png");
const copyid = require("../../images/bg/copyid.png");
const down68 = require("../../images/bg/down68.png");

const ICON_VS = require("../../images/icons/VS.png");
const ICON_VS1 = require("../../images/icons/VS1.png");
const ICON_JUBAO = require("../../images/icons/jubao.png");
const ICON_CHANGE_ROUTER = require("../../images/icons/ic_change_router.png");
// const ICON_LOGO = require("../../images/change/bbq.png");
// const ICON_PRIVATE = require("../../images/icons/sixin_icon1.png");
// const ICON_COPY = require("../../images/icons/fuzhi_icon1.png");
// const ICON_SHARE = require("../../images/icons/fenxiang_icon1.png");




//房间首页  roomData
class MoviePlayerPage extends React.Component {

    constructor(props) {
        super(props);
        this.player = null;
        let params = props.match.params;
        this.matchType = 0;
        this.matchId = 0;
        this.roomId = 0;
        if (params.matchType != 0 && params.matchType != undefined && params.matchType != 'undefined') {
            this.matchType = params.matchType;
        }
        if (params.matchId != 0 && params.matchId != undefined && params.matchId != 'undefined') {
            this.matchId = params.matchId;
        }
        if (params.room_id != 0 && params.room_id != undefined && params.room_id != 'undefined') {
            this.roomId = params.room_id;
        }

        let isStar = AppData.isStarMatch(this.matchType, this.matchId);

        let data = props.location.data;
        if (data) {
            AppUtils.setStorageObj('MOVIE_PLAYER_LOACATION_DATA', props.location.data);

        } else {
            data = AppUtils.getStorageObj('MOVIE_PLAYER_LOACATION_DATA');
        }

        this.state = {
            data: data,
            opened: true,
            value: 0,
            matchData: null,
            roomData: null,
            liveSource: null,
            param: data,
            TabTexts: [],
            bannerDatas: [],
            isStar: isStar,
            isStarAnchor: false,
            showDownload: false,
            qrcode: '',
            copy_content: '',
            set_data: '',
            hiddenButton: true,
            overflow: 'scroll',
            offChant: false,
            roomID: '',
            isReset: true,
            routerIdx: 0
        };

        this.params = {
            slidesPerView: 'auto',
            spaceBetween: 0,
        };

        console.log('MoviePlayerPage', props);
        this.showDownLoad = this.isWebClip()
    }

    componentDidMount() {
        this._requestDatas();
        this.getBanners();
        this.watchLive('in');
        this.encryptionLiveLog();
        this.encryptionQrcode();
        AppUtils.YMPush('MAIN', 'MoviePlayerPage');
        AppData.getShareConfig()

        let { os, token, uid, fastkey, roomIp, roomPort, customerId, fid } = this.props.match.params;
        if (!AppData.me.isLogin() && os != 'ios' && !AppData.me.isYk) {
            AppData.login(false);
        }

        if (os == 'ios') {
            AppData.me.token = token;
            AppData.os = os;
            IMApp.version = ""
            AppUtils.setStorageItem('uid', uid)
            IMApp.user.uid = uid;
            IMApp.user.fastkey = fastkey;
            AppUtils.setStorageItem('fastkey', fastkey)
        }

        if (customerId != 0) {
            AppData.me.customer_id = customerId
        }

        if (fid && fid != 0) {
            AppData.me.free_id = fid
        }


        if (token && token.length > 6) {
            AppData.me.token = token
        }

        IMEventEmitter.on(IMEvent.REF_ROOM, this.connect, this);
        DeviceEventEmitter.on(EventName.EVENT_SHOW_DOWNLOAD, this.onShowDownload, this);

        if (!this.isWebClip() && Profile.showDownload) {
            this.jumplanuch = setInterval(() => {
                if (!this.state.showDownload) {
                    this.setState({ showDownload: true });
                }
            }, 60 * 1000 * 3);
        }
        this.connectTimeOut = setTimeout(() => {
            IMApp.user.uid = uid;
            IMApp.user.fastkey = fastkey;
            this.toConnectSocket(uid, fastkey)
        }, 1000)
    }

    componentWillUnmount() {
        this.connectTimeOut && clearTimeout(this.connectTimeOut);
        this.jumplanuch && clearInterval(this.jumplanuch);
        IMEventEmitter.off(IMEvent.REF_ROOM, this.connect, this);
        DeviceEventEmitter.off(EventName.EVENT_SHOW_DOWNLOAD, this.onShowDownload, this);

        this.setState = () => false;
        this.watchLive('out');
        roomSocketMgr.closeWebSocket();
        if (this.state.offChant) {
            FIMUtils.quitGroup(this.state.roomID)
        }

    }

    toConnectSocket = async (uid, fastkey) => {
        //去调一下登录，拿到端口号和ip
        let { os } = this.props.match.params;
        if (os == "ios") { // ios 传过来的是ws端口，不能用
            let Imresult = await FIMUtils.fastLogin(0, fastkey);
            console.log("Imresult" + JSON.stringify(Imresult))
            if (Imresult.server && Imresult.server.length > 0) {
                AppUtils.setStorageItem('roomIp', Imresult.server[0].svrip)
                AppUtils.setStorageItem('roomPort', Imresult.server[0].websvrport)
            }
        }
        let address = AppUtils.getStorageItem("roomIp");
        let port = AppUtils.getStorageItem("roomPort");
        roomSocketMgr.connectServer(uid, fastkey, address, port);
    }

    isWebClip = () => {
        let { os } = this.props.match.params;
        let webclip = AppUtils.getQueryVariable('webclip');
        if (webclip && webclip == 1 || os == "ios" || AppUtils.isWebClip) {
            return true;
        }
        return false;
    }

    onShowDownload = () => {
        this.setState({ showDownload: true })
    }

    _onCloseDownload = () => {
        this.setState({ showDownload: false });
    }

    encryptionLiveLog = async () => {
        if (this.roomId) {
            let user_id = AppData.me.getUid();
            Apis.encryptionLiveLog(user_id, AppData.me.isLogin() ? 2 : 1, this.roomId);
        }
    }

    _isIos = () => {
        var u = navigator.userAgent.toLowerCase();
        if (u.indexOf("iphone") > -1 || u.indexOf("ios") > -1) {
            return true;
        }
        return false;
    }

    _onClickMessage() {
        if (AppData.os == 'ios') {
            const { free_id } = this.state.roomData
            let data = { "uid": free_id }
            if (window && window.webkit && window.webkit.messageHandlers) {
                window.webkit.messageHandlers.ChatAnchor.postMessage(JSON.stringify(data));
            }
        } else {
            let data = this.state.roomData;
            let userId = FIMUtils.createChatKey(data.free_id);//data.uid; 
            this.props.history.push({ pathname: '/privateletter/' + userId + '/userProfile', data: data.nickname });
            AppUtils.YMPush('CHAT', '私信主播');
        }
    }

    encryptionQrcode = async () => {
        console.log('encryptionQrcode', this.roomId);
        if (this.roomId) {
            let res = await Apis.encryptionQrcode(this.roomId);
            console.log('encryptionQrcode', res);
            if (res.code == 200 && res.data && res.data.qrcode) {
                this.setState({ qrcode: res.data.qrcode });
            }
        }
    }

    watchLive = async (type) => {
        if (AppData.me.isLogin()) {
            let user_id = AppData.me.getUid();
            Apis.encryptionCustomerInLive(user_id, type);
        }
    }

    setMovie = (is_has_chat) => {
        if (this.roomId == 0 && this.matchType == 0 && this.matchId == 0) {
            let TabTexts = [];
            // if (is_has_chat == 1) {
            //     TabTexts.push('聊天');
            // }
            TabTexts.push('直播');
            this.setState({ TabTexts: TabTexts })
        }
    }


    _requestDatas = async () => {
        let is_has_history = 1;
        let is_has_intelligence = 1;
        let is_has_analysis = 1;
        let is_has_chat = 1;

        if (!AppData.ServerConfig) {
            let res = await Apis.encryptionServerConfig();
            console.log("encryptionServerConfig", res);
            if (res.code == 200 && res.data) {
                AppData.ServerConfig = res.data;
                // AppData.app_68 = res.data.app_68
            }
        }

        is_has_history = AppData.ServerConfig.is_has_history;
        is_has_intelligence = AppData.ServerConfig.is_has_intelligence;
        is_has_analysis = AppData.ServerConfig.is_has_analysis;
        is_has_chat = AppData.ServerConfig.is_has_chat;

        console.log('_requestDatas');

        if (AppData.IsCloseChat) {
            is_has_chat = 2;
        }

        if (this.roomId != 0) {
            let result = await Apis.encryptionHostInfo(this.roomId);
            console.log('_requestDatas', result);
            if (result.code == 200) {
                this.state.copy_content = result.data.copy_content;
                this.state.set_data = result.data.set_data;
                if (result.data.match_id != 0) {
                    this.matchId = result.data.match_id;
                }
                if (result.data.matchType != 0) {
                    this.matchType = result.data.type_id;
                }
                this.getMatch(is_has_history, is_has_intelligence, is_has_analysis, is_has_chat);
                this.encryptionHostInfo();
                this.setRoomInfo(result.data, is_has_history, is_has_intelligence, is_has_analysis, is_has_chat);
            }
        } else {
            let host_id_copy = AppData.ServerConfig.host_id_copy;
            if (host_id_copy != null && host_id_copy != '') {
                this.state.copy_content = host_id_copy;
            }
            let pmd_content = AppData.ServerConfig.pmd_content;
            let pmd_url = AppData.ServerConfig.pmd_url;
            this.state.set_data = { pmd_content: pmd_content, pmd_url: pmd_url };

            this.getMatch(is_has_history, is_has_intelligence, is_has_analysis, is_has_chat);
            this.getLiveSource();
        }
    }

    getBanners = async () => {
        let result = await Apis.encryptionBanner();
        if (result.code == 200) {
            this.setState({ bannerDatas: result.data });
        }
    }

    getMatch = async (is_has_history, is_has_intelligence, is_has_analysis, is_has_chat) => {
        if (this.matchType && this.matchId) {
            let result = await Apis.encryptionMatchDetail(this.matchType, this.matchId);
            console.log('getMatch', result);
            if (result.code == 200) {
                if (this.roomId > 0) {
                    this.setState({ matchData: result.data });
                } else {
                    this.setMatch(result.data, is_has_history, is_has_intelligence, is_has_analysis, is_has_chat);
                }
            }
        } else {
            this.setMovie(is_has_chat);
        }
    }

    _onSnackClosed() {
        this.setState({
            snackopened: false,
        });
    }

    _onClickStar = () => {
        let isStar = !this.state.isStar;
        if (isStar) {
            this.starMatch();
        } else {
            this.unStarMatch();
        }
        console.log('_onClickStar', isStar);
        this.setState({ isStar: isStar });
    }

    _onClickShare = () => {
        console.log('_onClickShare');
    }

    _onClickJubao = () => {
        this.props.history.push({ pathname: '/accusation/' + this.roomId });
    }

    onClickMarquee = (url) => {
        AppUtils.YMPush("DOWNLOAD", "点击广播")
        if (url && url.length > 0) {
            OpenBrowser(url);
        }
    }

    starMatch = async () => {
        let ids = [];
        ids.push(this.matchId + '_' + this.matchType);
        let result = await Apis.encryptionFocusEvent(JSON.stringify(ids));
        console.log('starMatch', result);
        if (result.code == 200 && result.data) {
            AppData.getStarMatch(this.matchType);
        }
    }

    unStarMatch = async () => {
        let ids = [];
        ids.push(this.matchId + '_' + this.matchType);
        let result = await Apis.encryptionFocusEvent(JSON.stringify(ids), 1);
        console.log('unStarMatch', result);
        if (result.code == 200 && result.data) {
            AppData.getStarMatch(this.matchType);
        }
    }


    getLiveSource = async () => {
        if (this.matchType && this.matchId) {
            console.log("======");
            console.log(this.matchType);
            console.log(this.matchId);
            let result = await Apis.encryptionHostMatch(this.matchType, this.matchId);
            console.log('getLiveSource', result);
            if (result.code == 200) {
                this.setState({ liveSource: result.data });
            }
        }
    }

    encryptionHostInfo = async () => {
        if (this.roomId) {
            let result = await Apis.encryptionHostInfo(this.roomId);
            console.log('encryptionHostInfo', result);
            if (result.code == 200) {
                let liveSource = [];
                liveSource.push({
                    room_id: this.roomId,
                    live_url_list: result.data.live_url_list,
                    live_url_data: result.data.live_url_data
                })
                this.setState({ liveSource: liveSource });
            }
        }
    }

    onClickChangeRouter = () => {
        let routerIdx = this.state.routerIdx;
        this.state.routerIdx = routerIdx + 1;
        let liveUrl = this._getLiveSource();
        if (liveUrl && liveUrl.length > 0) {
            this.player && this.player.changeRouter(liveUrl)
        }
        AppUtils.YMPush('DOWNLOAD', 'changerouter');
    }

    _onClickStarAnchor = () => {
        let { os } = this.props.match.params;
        if (!AppData.me.isLogin()) {
            ToLogin(this.props, os)
            return;
        }

        let isStarAnchor = !this.state.isStarAnchor;
        this.setState({ isStarAnchor: isStarAnchor });
        if (isStarAnchor) {
            this.starAnchor();
        } else {
            this.unStarAnchor();
        }
    }

    starAnchor = async () => {
        let result = await Apis.encryptionFocusHost(JSON.stringify([this.props.data.user_id]));
        console.log('starAnchor', result);
        if (result.code == 200) {
            if (result.data) {
                AppData.getStarAnchor();
            }
        }
    }

    unStarAnchor = async () => {
        let result = await Apis.encryptionFocusHost(this.props.data.user_id, 1);
        console.log('unStarAnchor', result);
        if (result.code == 200) {
            if (result.data) {
                AppData.getStarAnchor();
            }
        }
    }

    setMatch(data, is_has_history, is_has_intelligence, is_has_analysis, is_has_chat) {
        let TabTexts = [];
        let match = new Match(data);
        let num = 3;
        if (match.living()) {
            // if (is_has_chat == 1) {
            //     TabTexts.push('聊天');
            //     num++;
            // }
            TabTexts.push('赛况');
        } else {
            TabTexts.push('赛况');
            // if (is_has_chat == 1) {
            //     TabTexts.push('聊天');
            //     num++;
            // }
        }
        if (is_has_intelligence == 1) {
            TabTexts.push('分析');
            num++;
        }
        if (is_has_history == 1) {
            TabTexts.push('指数');
            num++;
        }
        TabTexts.push('阵容');
        if (is_has_analysis == 1) {
            TabTexts.push('情报');
            num++;
        }
        TabTexts.push('直播');
        this.setState({ matchData: data, TabTexts: TabTexts })
    }

    _joinGroup = async (id) => {
        console.log("_joinGroup===>", id);
        if (id && id.length > 0) {
            await FIMUtils.joinGroup(id); //加入房间
        }
    }

    //socket连接上了，通知回来,如果是关闭聊天的，去加入房间
    connect = () => {
        // if (this.state.offChant && this.roomId != '' && this.roomId != 0) {
        //     this._joinGroup(this.roomId);
        // }
        // this._joinGroup(this.roomId);
    }

    setRoomInfo = (data, is_has_history, is_has_intelligence, is_has_analysis, is_has_chat) => {
        console.log('setRoomInfo', data);
        if (is_has_chat == 2 && data && data.groupId && data.groupId != '') {
            //关闭了聊天，但是还要加入一下房间，便于统计
            this.state.offChant = true;
            this.state.roomID = data.groupId;
        }
        let TabTexts = [];
        if (data.live_status == Live.STATUS_LIVE && data.push_status == Live.STATUS_LIVE) {
            let num = 4;
            // let overflow ='hidden';
            let overflow = 'scroll';
            if (is_has_chat == 1) {
                TabTexts.push('聊天');
                num++;
            }

            TabTexts.push('主播');
            if (this.matchId) {
                TabTexts.push('赛况');
                if (is_has_intelligence == 1) {
                    TabTexts.push('分析');
                    num++;
                }
                if (is_has_history == 1) {
                    TabTexts.push('指数');
                    num++;
                }
                TabTexts.push('阵容');
                if (is_has_analysis == 1) {
                    TabTexts.push('情报');
                    num++;
                }
                TabTexts.push('直播');
                this.setState({ roomData: data, TabTexts: TabTexts, overflow })
            } else {
                this.setState({ roomData: data, TabTexts: TabTexts, overflow })
            }
        } else {
            TabTexts.push('主播');
            TabTexts.push('直播');
            this.setState({ roomData: data, TabTexts: TabTexts })
        }
    }

    _getLiveSource = () => {
        const { data, liveSource, routerIdx } = this.state;
        console.log('_getLiveSource---', liveSource);
        let roomId = this.roomId;
        if (roomId == 0 && data && data.room_id > 0) {
            roomId = data.room_id;
        }
        let liveUrl = '';
        let live_url_data = '';
        if (liveSource && liveSource.length > 0) {
            for (let i = liveSource.length - 1; i >= 0; i--) {
                if (roomId > 0) {
                    if (liveSource[i].room_id == roomId) {
                        let idx = routerIdx % liveSource[i].live_url_list.length;
                        liveUrl = liveSource[i].live_url_list[idx]
                        live_url_data = liveSource[i].live_url_data;
                    }
                } else {
                    if (liveSource[i].live_url && liveSource[i].push_status == Live.STATUS_LIVE) {
                        liveUrl = liveSource[i].live_url;
                        live_url_data = liveSource[i].live_url_data;
                    }
                }
            }
        }
        if (data && data.live_type != 1) {
            if (data && data.live_url && data.live_url.length > 0) {
                liveUrl = data.live_url;
            }
        }

        if (liveUrl && liveUrl != '') {
            if (liveUrl.startsWith('rtmp://')) {
                liveUrl = liveUrl.replace('rtmp://', 'https://');
                liveUrl = liveUrl + '.m3u8' + live_url_data;
            }
        } else {
            const liveData = this.state.param
            if (liveData && liveData.match_id == 0 && liveData.match_type == 0) {
                liveUrl = liveData.live_url
            }
        }
        return liveUrl;
    }

    _onRefresh() {
        this.setState({ refreshing: true })
        this._requestDatas();
    }

    _handleChange = (val) => {
        console.log('_handleChange', val);
        console.log(this.state.TabTexts[0]);

        let overflow = 'scroll';

        if (this.state.TabTexts[val] == '聊天') {
            overflow = 'hidden';
        }

        if (this.state.value != val) {
            this.setState({ value: val, overflow })
        }
    }

    _showAlert = () => {

    }

    _handleTimeOut = () => {
    }

    _onPlayerReady = () => {

    }


    _playValid = () => {

    }

    onCopy = () => {
        if (this.state.copy_content == '') {
            this.setState({ snackopened: true, snackmessage: '主播没有设置id' })
        } else {
            this.setState({ snackopened: true, snackmessage: '主播ID已复制，快去添加哦～' })
        }

    }
    onCopyMatch = () => {
        this.setState({ snackopened: true, snackmessage: '分享地址复制成功' })
        AppUtils.YMPush('DOWNLOAD', '分享比赛');
    }

    onPrivateClick = () => {
        this.setState({ snackopened: true, snackmessage: '复制成功,快去添加吧' })
        // const { roomData } = this.state;
        // this.props.history.push({ pathname: '/privateletter/' + roomData.user_id + '/userProfile', data: roomData.nickname });
    }


    _renderAnchor() {
        const { classes } = this.props;
        const { param, bannerDatas } = this.state;
        return (
            <Grid container alignItems='center' direction='column' style={{ backgroundColor: '#000' }} >
                <MStatusBar />
                <Grid container alignItems='center' style={{
                    width: '100vw',
                    height: '56vw',
                    backgroundSize: '100% 100%',
                }}>
                    {
                        bannerDatas && bannerDatas.length > 0 && <Swiper {...this.params} >
                            <Grid container justifyContent='center' alignItems='center' direction='column' style={{ width: '64vw', height: '36vw', paddingTop: 16 }}>
                                <Grid container justifyContent='center' alignItems='center' direction='column' style={{ width: '56vw', height: '32vw', backgroundColor: '#343138', borderRadius: 10 }}>
                                    <Avatar src={param ? param.portrait : ''} className={classes.avatar} style={{ position: 'absolute', top: 0 }}></Avatar>
                                    <Typography style={{ fontSize: 12, color: '#FFFFFF' }}>主播暂不在播哦</Typography>
                                    <Typography style={{ fontSize: 12, color: '#878787' }}>关注主播可收到开播提醒</Typography>
                                </Grid>
                            </Grid>
                            {
                                bannerDatas.map((item, i) => (
                                    <Grid key={i} container justifyContent='center' alignItems='center' direction='column' style={{ width: '64vw', height: '36vw', paddingTop: 16 }}>
                                        <img key={i} src={item.cover} className={classes.bannerImg} alt='banner'></img>
                                    </Grid>
                                ))
                            }
                        </Swiper>
                    }
                </Grid>
            </Grid>
        );
    }

    _renderMatch() {
        const { param, matchData } = this.state;
        let backgroud = param && param.room_cover ? param.room_cover : BACK_BASKETBALL;
        let homeName = '';
        let awayName = '';
        let leagueName = '';
        let status = '';
        let homeScore = '';
        let awayScore = '';
        let time = '';
        let homeLog = '';
        let away_log = '';
        let vs = ICON_VS;

        if (param) {
            let match = new Match(param);
            homeName = param.home_name ? param.home_name : '';
            awayName = param.away_name ? param.away_name : '';
            leagueName = param.short_name_zh ? param.short_name_zh : '';
            if (param.type_id == MatchType.BASKETBALL) {
                backgroud = BACK_BASKETBALL;
            } else {
                backgroud = BACK_FOOTBALL;
            }
            homeScore = match.getHomeScore();
            awayScore = match.getAwayScore();

            time = param.match_time ? DateUtils.dateFormat(param.match_time) : '';
            status = match.getStatus();
            homeLog = param.home_log;
            away_log = param.away_log;
            if (match.showScore()) {
                vs = ICON_VS;
            } else {
                vs = ICON_VS1;
            }

        }

        if (matchData) {
            let match = new Match(matchData);
            homeName = matchData.home_name;
            awayName = matchData.away_name;
            leagueName = matchData.short_name_zh;
            if (matchData.type_id == MatchType.BASKETBALL) {
                backgroud = BACK_BASKETBALL;
            } else {
                backgroud = BACK_FOOTBALL;
            }
            homeScore = match.getHomeScore();
            awayScore = match.getAwayScore();
            time = DateUtils.dateFormat(matchData.match_time);
            status = match.getStatus();
            homeLog = matchData.home_log;
            away_log = matchData.away_log;
            if (match.showScore()) {
                vs = ICON_VS;
            } else {
                vs = ICON_VS1;
            }
        }


        return (
            <Grid container alignItems='center' style={{
                backgroundSize: 'cover',
                backgroundImage: `url(${backgroud})`,
                backgroundRepeat: 'no-repeat',
                width: '100vw',
                height: '56vw',
                backgroundPositionX: 'center'
            }}>
                <MStatusBar />
                <Grid container justifyContent='center' direction='column' style={{ width: '100%' }}>
                    <Grid container justifyContent='center' direction='column' style={{ textAlign: 'center' }}>
                        <Typography style={{ fontSize: 10, color: '#FFFFFF' }}>{leagueName}</Typography>
                        <Typography style={{ fontSize: 10, color: '#FFFFFF', marginTop: 4 }}>{time}</Typography>
                    </Grid>
                    <Grid container justifyContent='center' direction='column' style={{ textAlign: 'center', marginTop: 24 }}>
                        <Typography style={{ fontSize: 10, color: '#FFFFFF' }}>{status}</Typography>
                        <Grid container justifyContent='center' alignItems='center' direction='row'>
                            <Grid container alignItems='center' direction='column' style={{ maxWidth: '30vw' }}>
                                <img src={homeLog} style={{ width: 45, height: 45, objectFit: 'scale-down' }} />
                                <Typography style={{ fontSize: 12, color: '#FFFFFF', marginTop: 4 }}>{homeName}</Typography>
                            </Grid>
                            <Grid container alignItems='center' direction='row' style={{ flex: 1 }} >
                                <Grid container alignItems='center' direction='row' justifyContent='flex-end' style={{ flex: 1 }}>
                                    <Typography style={{ fontSize: 30, color: '#FFFFFF', maxWidth: 48, marginRight: 8 }}>{homeScore}</Typography>
                                </Grid>
                                <img src={vs} style={{ width: 30, height: 30, objectFit: 'scale-down' }} />
                                <Grid container alignItems='center' direction='row' justifyContent='flex-start' style={{ flex: 1 }}>
                                    <Typography style={{ fontSize: 30, color: '#FFFFFF', maxWidth: 48, marginLeft: 8 }}>{awayScore}</Typography>
                                </Grid>
                            </Grid>
                            <Grid container alignItems='center' direction='column' style={{ maxWidth: '30vw' }}>
                                <img src={away_log} style={{ width: 45, height: 45, objectFit: 'scale-down' }} />
                                <Typography style={{ fontSize: 12, color: '#FFFFFF', marginTop: 4 }}>{awayName}</Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        );
    }

    _createChildren = (item, i, value, data) => {

        let showAd = false;
        let ad_status = AppData.ServerConfig.ad_status
        if (this.roomId != '0' && this.roomId != 0 && this.roomId > 0) {
            if (ad_status == 2 || ad_status == 3) {
                showAd = true;
            }
        } else if (this.matchId > 0 && this.matchType > 0 && this.matchId != 0 && this.matchId != '0') {
            if (ad_status == 1 || ad_status == 3) {
                showAd = true;
            }
        }

        let tdata = { match_type: this.matchType, match_id: this.matchId, room_id: this.roomId, groupId: data.groupId, free_id: data.free_id }
        Object.assign(data, tdata);
        if (item == '聊天' && this.state.roomData != null) {
            const team = [this.state.roomData.home_name, this.state.roomData.away_name]

            return (<MTabPanel key={i} value={value} index={i} style={{ width: '100%' }}><MovieChat marquee={this.state.set_data} data={data} team={team} tdata={tdata} roomData={this.state.roomData} copyContent={this.state.copy_content} /> </MTabPanel>);
        } else if (item == '主播') {
            return (<MTabPanel key={i} value={value} index={i} style={{ width: '100%' }}><MovieAnchor data={data} /> </MTabPanel>);
        } else if (item == '赛况') {
            if (this.matchType == MatchType.BASKETBALL) {
                return (<MTabPanel key={i} value={value} index={i} style={{ width: '100%' }}><MovieStateBasket data={data} showAd={showAd} /></MTabPanel>);
            } else {
                return (<MTabPanel key={i} value={value} index={i} style={{ width: '100%' }}><MovieStateFootball data={data} showAd={showAd} /></MTabPanel>);
            }
        } else if (item == '分析') {
            if (this.matchType == MatchType.BASKETBALL) {
                return (<MTabPanel key={i} value={value} index={i} style={{ width: '100%' }}><MovieAnalyseBasketBall data={data} /></MTabPanel>);
            } else {
                return (<MTabPanel key={i} value={value} index={i} style={{ width: '100%' }}><MovieAnalyseFootBall data={data} /></MTabPanel>);
            }
        } else if (item == '指数') {
            return (<MTabPanel key={i} value={value} index={i} style={{ width: '100%' }}><MovieIndex data={data} /></MTabPanel>);
        } else if (item == '阵容') {
            if (this.matchType == MatchType.BASKETBALL) {
                return (<MTabPanel key={i} value={value} index={i} style={{ width: '100%' }}><MovieTeamBasketball data={data} /></MTabPanel>);
            } else {
                return (<MTabPanel key={i} value={value} index={i} style={{ width: '100%' }}><MovieTeamFootball data={data} /></MTabPanel>);
            }
        } else if (item == '情报') {
            return (<MTabPanel key={i} value={value} index={i} style={{ width: '100%' }}><MovieIntelligence data={data} /></MTabPanel>);
        } else if (item == '直播') {
            return (<MTabPanel key={i} value={value} index={i} style={{ width: '100%' }}><MovieLive data={data} /></MTabPanel>);
        }
    }

    _renderNoLiving() {
        if (this.roomId > 0) {
            return this._renderAnchor();
        }
        return this._renderMatch();
    }

    fndown68 = () => {
        OpenBrowser(AppData.ServerConfig.app_68)
        AppUtils.YMPush('DOWNLOAD', 'download68');
    }
    fncopyid = () => {
        AppUtils.YMPush('DOWNLOAD', 'copyid');
        if (this.state.copy_content == '') {
            this.setState({ snackopened: true, snackmessage: '主播没有设置id' })
        } else {
            this.setState({ snackopened: true, snackmessage: '主播ID复制成功，快去撩主播哦～' })
        }
    }



    render() {
        const { classes } = this.props;
        let {
            opened,
            value,
            matchData,
            data,
            roomData,
            TabTexts,
            isStarAnchor,
            qrcode,
            copy_content,
            snackopened,
            snackmessage,
            liveSource,
            showDownload,
            set_data
        } = this.state;

        if (matchData) {
            console.log('matchData', matchData.groupId);
        }


        let liveUrl = this._getLiveSource();
        let isLiving = false;

        if (roomData && this.roomId > 0) {
            if (roomData.live_status == Live.STATUS_LIVE && roomData.push_status == Live.STATUS_LIVE) {
                isLiving = true;
            }
            if (!isStarAnchor) {
                isStarAnchor = AppData.isStarAnchor(roomData.user_id);
            }
        } else if (matchData) {
            let match = new Match(matchData);
            if (match.living()) {
                isLiving = true;
            }
        } else {
            // let data = null;
            if (this.props.location && this.props.location.data) {
                data = this.props.location.data;
            }
            if (data) {
                if (data.live_type == Live.TYPE_CUSTOM) {
                    isLiving = true;
                    let tmp = decodeURIComponent(AppUtils.getQueryVariable('liveUrl'));
                    if (tmp && tmp.length > 0 && tmp != "null") { // ios 重地址栏传过来的参数
                        liveUrl = tmp;
                    } else {
                        if (data && data.live_url && data.live_url.length > 0) {
                            liveUrl = data.live_url;
                        }
                    }
                }
            } else {
                let tmp = decodeURIComponent(AppUtils.getQueryVariable('liveUrl'));
                if (tmp && tmp.length > 0) { // ios 重地址栏传过来的参数
                    isLiving = true;
                    liveUrl = tmp;
                }
            }
        }

        if (!liveUrl || liveUrl.length == 0) {
            isLiving = false;
        }

        if (liveSource == null && data && data.live_type != Live.TYPE_CUSTOM) {
            isLiving = false;
        }

        let online = "";
        if (roomData) {
            online = "直播间在线：" + roomData.heat + "人"
        } else if (data && data.heat > 0) {
            online = "直播间在线：" + data.heat + "人"
        }
        let showMarquee = false;
        if (AppData.ServerConfig && AppData.ServerConfig.is_has_chat == 1) {
            if (set_data && set_data.pmd_content && set_data.pmd_content.length > 0) {
                showMarquee = true;
            } else {
                showMarquee = false;
            }
        } else {
            showMarquee = false;
        }


        let videoJsOptions = {
            autoplay: true,  //自动播放
            language: 'zh-CN',
            controls: true,  //控制条
            preload: 'auto',  //自动加载
            errorDisplay: true,  //错误展示 
            height: window.screen.height,
            userActions: { hotkeys: true },
            sources: [{ src: liveUrl, type: "application/x-mpegURL", }]
        };

        return (
            <Grid container direction='column' >
                <List className={classes.root} style={{ backgroundColor: '#fff', borderRadius: 0, scrollbarWidth: 'none' }} >
                    <ListSubheader className={classes.listHeader} style={{ borderRadius: 0 }}>
                        {
                            isLiving && <Grid container alignItems='center' justifyContent='center' direction='column' style={{ height: 48 }}>
                                <MStatusBar />
                                <Grid container alignItems='center' justifyContent='space-between' direction='row' >
                                    <Grid container alignItems='center' direction='row' style={{ flex: 1 }} >
                                        {
                                            isLiving && <MBackIcon className={classes.backIcon} />
                                        }
                                        <div style={{ marginLeft: 40, color: '#2A2A2A', fontSize: 13 }}>{online}</div>
                                    </Grid>
                                    <Grid container alignItems='center' direction='row' style={{ width: 72, marginRight: 12, zIndex: 100001 }} >
                                        <IconButton style={{ padding: 0 }} onClick={() => this.onClickChangeRouter()}>
                                            <img src={ICON_CHANGE_ROUTER} style={{ width: 70, height: 25, }} />
                                        </IconButton>
                                    </Grid>
                                </Grid>
                            </Grid>
                        }
                        {
                            isLiving ? <Player
                                ref={(player) => this.player = player}
                                {...videoJsOptions}
                                className={classes.player}
                                callTime={5 * 60}
                                onChangeRouter={() => this.onClickChangeRouter()}
                                callTimeBack={() => this._handleTimeOut()}
                                playValid={() => this._playValid()}
                                onPlayerReady={() => this._onPlayerReady()}
                            >
                            </Player>

                                : this._renderNoLiving()
                        }
                        <AppBar className={classes.header}>
                            <MStatusBar />
                            <Toolbar style={{ justifyContent: 'center', alignItems: 'center' }}>
                                {
                                    !isLiving && <MBackIcon className={classes.backIcon1} appBarColor='#FC4545' />
                                }
                                {
                                    !isLiving && <Grid style={{ position: 'absolute', right: 0 }}>
                                        {/* {
                                            this.matchType > 0 && this.matchId > 0 && <ButtonBase className={classes.iconButton} disableRipple onClick={() => this._onClickStar()}>
                                                <img src={isStar ? ICON_SCStar : ICON_SC} style={{ width: 19, height: 19, marginRight: 16 }} />
                                            </ButtonBase>
                                        } */}
                                        {
                                            this.roomId > 0 && isLiving && <ButtonBase className={classes.iconButton} disableRipple onClick={() => this._onClickJubao()}>
                                                <img src={ICON_JUBAO} style={{ width: 19, height: 19, marginRight: 16 }} />
                                            </ButtonBase>
                                        }
                                        {/* <ButtonBase className={classes.iconButton} disableRipple onClick={() => this._onClickShare()}>
                                            <img src={ICON_FX} style={{ width: 19, height: 19, marginRight: 16 }} />
                                        </ButtonBase> */}
                                    </Grid>
                                }
                            </Toolbar>
                        </AppBar>
                        <Grid container justifyContent='center' alignItems='center' direction='column' >
                            {showMarquee && <div style={{ width: '100vw' }} onClick={() => this.onClickMarquee(set_data.pmd_url)}>
                                <DrawMarquee text={set_data.pmd_content} />
                            </div>}
                            {/* {(!this.showDownLoad) && <Download />} */}
                            {
                                AppData.ServerConfig && AppData.ServerConfig.is_has_chat == 1 && <div className={classes.hDown}>
                                    <div onClick={() => this.fndown68()} className={classes.down68}></div>
                                    <CopyToClipboard text={copy_content} onCopy={() => this.fncopyid()}>
                                        <div className={classes.copyid}></div>
                                    </CopyToClipboard>
                                </div>
                            }


                            {/* <img src={ICON_SHARE_DOWN} style={{ width: '100vw', height: '9.5vw' }} /> */}
                            <Grid container alignItems='center' justifyContent='center' style={{ backgroundColor: '#FFF', width: '100%' }}>
                                <div style={{ width: '74vw' }}>
                                    {
                                        TabTexts.length != 0 && <Tabs
                                            value={value}
                                            variant='fullWidth'
                                            onChange={(e, val) => this._handleChange(val)}
                                            TabIndicatorProps={{ children: <TabIndicator />, style: { backgroundColor: 'transparent', marginBottom: 1.5 } }}
                                            style={{ minHeight: 48, width: '74vw' }}
                                        >
                                            {
                                                TabTexts.map((item, i) => (
                                                    <Tab key={i} label={item} style={{ color: value == i ? '#0D0D0D' : '#878787', fontSize: 14, padding: 0, minHeight: 48, minWidth: 48 }}></Tab>
                                                ))
                                            }
                                        </Tabs>
                                    }
                                </div>
                                {
                                    AppData.ShareUrl && AppData.ShareUrl.length > 0 &&
                                    <div style={{ width: '20vw', display: 'flex', justifyContent: 'center', alignItems: 'center', marginLeft: 15 }}>
                                        <CopyToClipboard text={AppData.ShareUrl} onCopy={() => this.onCopyMatch()}>
                                            <ButtonBase className={classes.copyButton}  >
                                                <img src={sharlMatch} style={{ width: '20vw' }} />
                                            </ButtonBase>
                                        </CopyToClipboard>
                                    </div>

                                }

                            </Grid>
                            <Grid style={{ height: 1, backgroundColor: '#F7F7F7', width: '100%' }}></Grid>
                        </Grid>
                    </ListSubheader>
                    {
                        <Grid container direction='column' style={{ width: '100vw' }}>
                            {
                                TabTexts.map((item, i) => (
                                    this._createChildren(item, i, value, Object.assign(matchData ? matchData : {}, roomData))
                                ))
                            }
                        </Grid>
                    }
                    {/* <MEnvelope /> */}
                    {
                        qrcode && qrcode.length > 0 && <img src={qrcode} className={classes.qrcode}></img>
                    }
                </List>

                {showDownload && <Download onClose={() => this._onCloseDownload()} />}

                {snackopened && <Snackbar
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    color='black'
                    open={snackopened}
                    onClose={() => this.setState({ snackopened: false })}
                    message={snackmessage}
                    autoHideDuration={1000}>
                </Snackbar>}
            </Grid>
        );
    }
}

export default withRouter(withStyles((theme) => ({
    root: {
        flexGrow: 1,
        padding: 0,
        backgroundColor: '#FFF',
        borderRadius: 0,
        // overflow:'hidden'
    },
    hDown: {
        width: '100vw',
        height: '35px',
        backgroundImage: `url(${whbgc})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        display: 'flex',
        justifyContent: 'space-between'
    },

    down68: {
        width: '48vw',
        height: '35px',
        backgroundImage: `url(${down68})`,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center'
    },
    copyid: {
        width: '48vw',
        height: '35px',
        backgroundImage: `url(${copyid})`,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center'
    },
    copyBtn: {
        width: "12vw",
        height: "20vw",
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'

    },
    player: {
        width: '100%',
        height: 'auto',
        position: 'absolute',
        zIndex: 0,
    },
    header: {
        backgroundColor: 'transparent',
        zIndex: 1,
        position: 'absolute',
        boxShadow: 'none',
    },
    backIcon: {
        color: '#0D0D0D',
        zIndex: 10001,
    },
    backIcon1: {
        color: '#FFF',
    },
    listHeader: {
        padding: theme.spacing(0, 0, 0, 0),
        margin: theme.spacing(0, 0, 0, 0),
        lineHeight: '64px'
    },
    bannerImg: {
        width: "56vw",
        height: "32vw",
        objectFit: 'cover',
        borderRadius: 10,
        marginLeft: 8,
    },
    avatar: {
        width: 50,
        height: 50,
    },
    iconButton: {
        padding: theme.spacing(0, 0, 0, 0),
        margin: theme.spacing(0, 0, 0, 0),
    },
    snackbar: {
        marginTop: '45vh',
    },
    dyButton: {
        minWidth: 50,
        backgroundColor: '#FC3035',
        height: 25,
        borderRadius: 12.5,
        marginRight: 8,
        color: '#FFF',
        fontSize: 12,
        position: 'absolute',
        right: 0
    },
    dy1Button: {
        minWidth: 50,
        backgroundColor: '#FFF',
        height: 25,
        borderRadius: 12.5,
        marginRight: 8,
        color: '#878787',
        fontSize: 12,
        position: 'absolute',
        right: 0
    },
    qrcode: {
        width: '25vw',
        height: '25vw',
        position: 'fixed',
        right: 8,
        borderRadius: 8,
        bottom: '25vh'
    },
    copyButtonGrid: {
        zIndex: 1100001,
        maxWidth: 60,
        position: 'absolute',
        right: 0,
        bottom: 100
    },
    copyButton: {

    },

}))(MoviePlayerPage));